export default {
  no_storefront_found: {
    title: 'Keine storefront gefunden',
    description: 'Bitte erstellen Sie eine storefront.',
  },
};
